export default __webpack_public_path__ + "static/media/deucesEmetyCard.fd834ae0.svg";